import React from 'react';
import { OverallStatsDisplayProps } from '../../../types/DocumentManagement';
import styles from '../../../styles/DocumentManagement.module.css';

const OverallStatsDisplay: React.FC<OverallStatsDisplayProps> = ({
  stats,
  title = 'Overall Completion',
  className = '',
  showDetails = true,
}) => {
  if (!stats) {
    return null;
  }

  const getCompletionClass = (rate: number): string => {
    if (rate >= 90) return styles.completionSuccess;
    if (rate >= 70) return styles.completionWarning;
    return styles.completionDanger;
  };

  const getBarFillClass = (rate: number): string => {
    if (rate >= 90) return styles.progressBarFillSuccess;
    if (rate >= 70) return styles.progressBarFillWarning;
    return styles.progressBarFillDanger;
  };

  return (
    <div className={`${styles.overallStatsSummary} ${className}`}>
      <div className={styles.statsContainer}>
        {/* Completion Rate */}
        <div className={styles.statItem}>
          <span className={styles.statLabel}>{title}:</span>
          <span className={`${styles.statValue} ${getCompletionClass(stats.completionRate)}`}>
            {stats.completionRate.toFixed(1)}%
          </span>
        </div>

        {/* Completed Count */}
        <div className={styles.statItem}>
          <span className={styles.statLabel}>Completed:</span>
          <span className={styles.statValue}>
            {stats.completedItems}/{stats.totalItems}
          </span>
        </div>

        {/* Missing Documents Badge (only show if > 0) */}
        {showDetails && stats.missingItems > 0 && (
          <div className={styles.statItem}>
            <span className={`${styles.statBadge} ${styles.missing}`}>
              {stats.missingItems} missing
            </span>
          </div>
        )}

        {/* Expired Documents Badge (only show if > 0) */}
        {showDetails && stats.expiredItems > 0 && (
          <div className={styles.statItem}>
            <span className={`${styles.statBadge} ${styles.expired}`}>
              {stats.expiredItems} expired
            </span>
          </div>
        )}
      </div>

      {/* Progress bar */}
      <div className={styles.progressBarTrack}>
        <div
          className={`${styles.progressBarFill} ${getBarFillClass(stats.completionRate)}`}
          style={{ width: `${Math.min(stats.completionRate, 100)}%` }}
        />
      </div>
    </div>
  );
};

export default React.memo(OverallStatsDisplay);
